import { Injectable, inject } from '@angular/core';

import { Price } from '@bpos/v1/teaser';
import { ApiService } from '@frontend/sports/common/api-utils';
import { usePreloaderData } from '@frontend/sports/common/core/utils/preloaded-data';
import { WINDOW } from '@frontend/vanilla/core';
import { Observable } from 'rxjs';

export interface TeaserPriceDetails {
    teaserPriceVersionId: number;
    pointsPrices: { [key: string]: Price };
}

@Injectable()
export class TeaserBetApiService {
    private readonly _window = inject(WINDOW);

    constructor(private apiService: ApiService) {}

    @usePreloaderData({
        preloader: function (this: TeaserBetApiService) {
            return this._window.MS2JS?.TeaserPricesTableLoader;
        },
    })
    getLatestTeaserPrices(): Observable<TeaserPriceDetails> {
        return this.apiService.get<TeaserPriceDetails>('teaserbet/getLatestTeaserPrices', null, {
            retryCount: 10,
            retryDelay: 500,
            retryOnStatus: [400],
        });
    }
}
